module.exports = __webpack_public_path__ + "static/netlify-fc1c11c02d92d586174b28bfaac3055e.svg";